<template>
  <div class="auth-screen">
    <section class="auth-brand" aria-hidden="true">
      <div class="auth-brand-isi">
        <div class="auth-wordmark">AccuTrax</div>
        <p class="auth-tagline">Penjualan, stok dan pembukuan toko dalam satu tempat.</p>
      </div>
      <img class="auth-kodok" src="/brand/kodok.svg" alt="" width="420" height="321" />
    </section>

    <section class="auth-panel">
      <div class="auth-card">
        <div class="auth-mini-brand">
          <span class="auth-mini-mark"><img src="/brand/kodok-ikon.svg" alt="" width="34" height="34" /></span>
          <span>AccuTrax</span>
        </div>
        <h1 class="auth-title">{{ title }}</h1>
        <p v-if="description" class="auth-description">{{ description }}</p>
        <slot />
      </div>
      <p class="auth-foot">
        Butuh bantuan? <a href="https://support.accutrax.id" target="_blank" rel="noopener">support.accutrax.id</a>
      </p>
    </section>
  </div>
</template>

<script>
import { useRoute } from "vue-router";
import { watch, ref } from "vue";

export default {
  setup() {
    const route = useRoute();

    const title = ref(route.meta.title);
    const description = ref(route.meta.description || "");

    watch(
      () => route.path,
      () => {
        title.value = route.meta.title;
        description.value = route.meta.description || "";
      }
    );
    return {
      title,
      description,
    };
  },
};
</script>

<style>
.auth-screen {
  width: 100%;
  min-height: 100vh;
  display: grid;
  grid-template-columns: minmax(360px, 46%) 1fr;
  background: var(--ground);
}

.auth-brand {
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 48px 48px 0;
  background: var(--bar);
  color: var(--bar-ink);
}
.auth-wordmark {
  font-size: 40px;
  font-weight: 700;
  letter-spacing: -0.03em;
  line-height: 1.1;
}
.auth-tagline {
  margin: 12px 0 0;
  max-width: 26ch;
  font-size: 20px;
  line-height: 1.4;
  color: var(--bar-ink-muted);
  text-wrap: balance;
}
.auth-kodok {
  align-self: center;
  width: min(420px, 88%);
  height: auto;
  margin-top: 32px;
  /* Kodok duduk di "tanah" kertas di bawah panel. */
  filter: drop-shadow(0 18px 24px rgba(5, 40, 40, 0.35));
}
.auth-brand::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 56px;
  background: var(--brand-paper);
  border-top: 4px solid var(--brand-sun);
  z-index: 0;
}
.auth-brand .auth-kodok {
  position: relative;
  z-index: 1;
  margin-bottom: 20px;
}

.auth-panel {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding: 40px 24px;
}
.auth-card {
  width: min(400px, 100%);
  padding: 32px 32px 28px;
  border-radius: 16px;
  background: var(--surface);
  border: 1px solid var(--line);
  box-shadow: 0 20px 44px -28px rgba(14, 110, 110, 0.45);
}
.auth-mini-brand {
  display: none;
  align-items: center;
  gap: 10px;
  margin-bottom: 18px;
  font-weight: 700;
  font-size: 18px;
  letter-spacing: -0.02em;
  color: var(--brand-ink);
}
.dx-swatch-dark .auth-mini-brand {
  color: var(--text);
}
.auth-mini-mark {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: var(--brand-paper);
  display: grid;
  place-items: center;
  overflow: hidden;
}
.auth-mini-mark img {
  margin-top: 4px;
}
.auth-screen .auth-card .auth-title {
  margin: 0 0 4px;
  font-weight: 700;
  font-size: 26px;
  line-height: 1.2;
  letter-spacing: -0.02em;
  color: var(--text);
}
.auth-description {
  margin: 0 0 8px;
  color: var(--text-muted);
}
.auth-foot {
  margin: 0;
  color: var(--text-muted);
  font-size: 14px;
}
.auth-foot a {
  color: var(--brand-ink);
  font-weight: 600;
}
.dx-swatch-dark .auth-foot a {
  color: var(--brand-leaf);
}

@media (max-width: 860px) {
  .auth-screen {
    grid-template-columns: 1fr;
  }
  .auth-brand {
    flex-direction: row;
    align-items: flex-end;
    padding: 20px 20px 0;
    min-height: 0;
  }
  .auth-wordmark {
    font-size: 28px;
  }
  .auth-tagline {
    font-size: 15px;
    margin-top: 6px;
  }
  .auth-brand-isi {
    align-self: center;
    padding-bottom: 28px;
  }
  .auth-brand::after {
    height: 28px;
    border-top-width: 3px;
  }
  .auth-brand .auth-kodok {
    width: 150px;
    margin: 0 0 6px;
    flex: none;
  }
  .auth-panel {
    justify-content: flex-start;
    padding: 32px 16px;
  }
  .auth-card {
    padding: 24px 20px;
  }
}
</style>
